document.addEventListener("DOMContentLoaded", function () {
  if (window.screen.width < 800) {
    // ----- MENU -----
    var menu = document.querySelector('.main_nav .show_menu');
    menu.addEventListener('click', toggleMenu);
    var menuForm = document.querySelector('.modal_parent');

    function toggleMenu() {
      if (menuForm.style.visibility === "visible") {
        closemenu();
      } else {
        menuForm.style.visibility = "visible";
        menuForm.style.opacity = "1";
      }
    }

    var closeMenu = document.querySelector('.main_nav .close_menu');
    closeMenu.addEventListener('click', closemenu);

    function closemenu() {
      menuForm.style.visibility = "hidden";
      menuForm.style.opacity = "0";
    }

    menuForm.addEventListener('click', function (event) {
      if (!event.target.closest('.inner')) {
        closemenu();
      }
    });
    // ----- END OF MENU -----

    // ----- SUB_MENU -----
    var arrowIcon = document.querySelectorAll('.submenu_mobile_icn');
    arrowIcon.forEach(function (i) {
      i.addEventListener('click', toggleSubmenu);
      function toggleSubmenu(e) {
        e.stopPropagation();
        e.preventDefault();
        if (this.parentNode.children[2].classList.contains("submenu_show")) {
          this.parentNode.children[2].classList.remove("submenu_show");
        } else {
          this.parentNode.children[2].classList.add("submenu_show");
        }
      }
    })
    // ----- END OF SUB_MENU -----
    //----- MOBILE SEARCH -----
    var searchIcon = document.querySelector(".main_header .mobile_search .search_icon");
    var searchForm = document.querySelector(".main_header .mobile_search .search_parent");
    var searchInput = document.querySelector(".main_header .mobile_search .search_input");
    if (searchIcon && searchForm) {
      searchIcon.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        searchForm.classList.toggle("visible");
      });
      searchForm.addEventListener("click", function (e) {
        if (!searchIcon.contains(e.target) && !searchInput.contains(e.target)) {
          searchForm.classList.remove("visible");
        }
      });
    }
    //----- END OF MOBILE SEARCH -----
  }
  if (window.screen.width > 800) {
    // ---- DESKTOP SEARCH ----
    var search = document.querySelector(".main_header .desktop_search .search_icon");
    if (search) {
      var searchForm = document.querySelector(".main_header .search_container");
      var searchIcon = document.querySelector(".main_header .desktop_search .search_icon");
      search.addEventListener("click", function toggleSearch(e) {
        e.preventDefault();
        e.stopPropagation();

        if (searchForm && searchIcon) {
          if (searchForm.classList.contains("visible")) {
            searchForm.classList.remove("visible");
            searchIcon.classList.remove("search_button");
          } else {
            searchForm.classList.add("visible");
            searchIcon.classList.add("search_button");
          }
        }
      });
    }
    //----- END OF DESKTOP SEARCH -----
    // ---- STICKY HEADER ----
    const header = document.querySelector(".main_header");
    const topPart = document.querySelector(".main_header .top_part");
    const mainPart = document.querySelector(".main_header .main_part");
    let lastScrollY = window.scrollY;

    window.addEventListener("scroll", () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY > lastScrollY) {
        // Scrolling down
        if (currentScrollY > header.offsetHeight) {
          topPart.classList.add("top_part_header");
          mainPart.classList.add("main_part_header");
        }
      } else {
        // Scrolling up
        if (currentScrollY < header.offsetHeight) {
          topPart.classList.remove("top_part_header");
          mainPart.classList.remove("main_part_header");
        }
      }
      lastScrollY = currentScrollY;
    });
    // ---- END OF STICKY HEADER ----
  }
  // ----- DESKTOP VERSION BUTTON ----------
  document.querySelector('#desk_mode').addEventListener('click', function () {
    document.querySelector('meta[name="viewport"]').setAttribute("content", "width=1323px")
  })
  // ----- END OF DESKTOP VERSION BUTTON ----------
  // ----- LANGUAGES -----
  // var Languages = document.querySelector('.main_header .translate');
  // Languages.addEventListener('click', DesktopToggleLanguages);
  // var Translate = document.querySelector('.translate .span');
  // function DesktopToggleLanguages() {
  //   if (Translate.classList.contains("languages")) {
  //     Translate.classList.remove("languages");
  //   } else {
  //     Translate.classList.add("languages");
  //   }
  // }
  // ----- END OF LANGUAGES -----
  // ---- CLOSE ADV ----
  document.addEventListener("click", function (e) {
    if (e.target.closest(".close_adv")) {
      const parent = e.target.closest(".close_adv").parentElement;
      if (parent) {
        parent.style.display = "none";
      }
    }
  });
  // ---- END OF CLOSE ADV ----
  // ----- TAB -----
  function setupTabs(tabHeaderSelector, tabContentSelector) {
    const tabHeaders = document.querySelectorAll(`${tabHeaderSelector} li`);
    const tabContents = document.querySelectorAll(`${tabContentSelector} > div`);
    tabHeaders.forEach(function (item) {
      item.addEventListener("click", function () {
        if (!item.classList.contains("active")) {
          const tabIndex = Array.prototype.indexOf.call(tabHeaders, item);
          const nthChild = tabIndex + 1;
          // Remove active class from all headers
          tabHeaders.forEach((header) => header.classList.remove("active"));
          // Add active class to the clicked header
          item.classList.add("active");
          // Remove active class from all contents
          tabContents.forEach((content) => content.classList.remove("active"));
          // Add active class to the corresponding content
          document
            .querySelector(`${tabContentSelector} > div:nth-child(${nthChild})`)
            .classList.add("active");
        }
      });
    });
  }
  // Set up tabs for FRONT_B
  setupTabs("#tab_header_b", "#content_b")
  // Set up tabs for FRONT_C
  setupTabs("#tab_header_c", "#content_c");
  // Set up tabs for SUB_LANDING_B & LANDING_B
  setupTabs("#tab_header", "#content");
  // // Set up tabs for LANDING_B
  // ----- END OF TAB -----

  // ---- AMP STORY -----
  if (document.querySelector(".ampstory_container")) {
    // carousel js just for desktop
    const isDesktop = window.matchMedia('(min-width: 769px)').matches;
    const carousel = document.querySelector('.ampstory');
    const prevButton = document.querySelector('.ampstory_carousel .prev');
    const nextButton = document.querySelector('.ampstory_carousel .next');

    if (isDesktop) {
      const itemWidth = carousel.querySelector('li').offsetWidth + parseInt(getComputedStyle(carousel).gap);
      let startX = 0,
        scrollLeft = 0,
        isDragging = false,
        isClick = true;

      const updateButtonState = () => {
        const maxScrollLeft = carousel.scrollWidth - carousel.offsetWidth;
        prevButton.disabled = Math.abs(carousel.scrollLeft) >= maxScrollLeft;
        nextButton.disabled = Math.abs(carousel.scrollLeft) === 0;
      };

      // Prevent default drag behavior on images and links
      carousel.querySelectorAll('img, a').forEach((el) => {
        el.addEventListener('mousedown', (e) => e.preventDefault());
      });

      // Scroll one item per button click
      prevButton.addEventListener('click', () => {
        carousel.scrollBy({
          left: -itemWidth,
          behavior: 'smooth'
        });
        setTimeout(updateButtonState, 300);
      });

      nextButton.addEventListener('click', () => {
        carousel.scrollBy({
          left: itemWidth,
          behavior: 'smooth'
        });
        setTimeout(updateButtonState, 300);
      });

      // Mouse drag functionality
      carousel.addEventListener('mousedown', (e) => {
        startX = e.pageX;
        scrollLeft = carousel.scrollLeft;
        isDragging = true;
        isClick = true; // Assume it's a click until movement is detected
        carousel.style.cursor = 'grabbing';
      });

      document.addEventListener('mousemove', (e) => {
        if (!isDragging) return;
        const deltaX = e.pageX - startX;
        if (Math.abs(deltaX) > 5) isClick = false; // If mouse moves, it's a drag
        carousel.scrollLeft = scrollLeft - deltaX;
      });

      document.addEventListener('mouseup', () => {
        if (isDragging) {
          isDragging = false;
          carousel.style.cursor = 'grab';
          updateButtonState();
        }
      });

      // Prevent links from activating during drag
      carousel.addEventListener('click', (e) => {
        if (!isClick) e.preventDefault(); // Prevent click if it was a drag
      });

      carousel.addEventListener('mouseleave', () => {
        if (isDragging) {
          isDragging = false;
          carousel.style.cursor = 'grab';
          updateButtonState();
        }
      });

      carousel.addEventListener('scroll', updateButtonState);
      updateButtonState();
    } else {
      prevButton.style.display = 'none';
      nextButton.style.display = 'none';
    }
  }
  // ---- END OF AMP STORY -----
  //---- FRONT_E ----
  if (document.getElementById("four_some_box")) {
    new Splide("#four_some_box", {
      gap: '20px',
      perMove: 1,
      perPage: 4,
      type: "loop",
      direction: "rtl",
      pagination: false,
      adaptiveHeight: false,
      breakpoints: {
        1000: {
          perPage: 3,
        },
        800: {
          perPage: 2,
        },
        500: {
          perPage: 1,
        },
      }
    }).mount();
  }
  //---- END OF FRONT_E ----
  //---- VIDEO BOX (FRONT K) ----
  if (document.getElementById("video_box")) {
    new Splide("#video_box", {
      gap: '20px',
      perMove: 1,
      perPage: 5,
      type: "loop",
      direction: "rtl",
      pagination: false,
      adaptiveHeight: false,
      breakpoints: {
        800: {
          perPage: 2,
        },
        600: {
          perPage: 1,
          gap: '12px',
        },
      }
    }).mount();
  }
  //---- END OF VIDEO BOX (FRONT K) ----
  //---- LANDING_A ----
  if (document.getElementById("main_news_landing")) {
    new Splide("#main_news_landing", {
      perPage: 1,
      type: "loop",
      interval: 4000,
      autoplay: true,
      direction: "rtl",
      adaptiveHeight: false,
    }).mount();
  }
  //---- END OF LANDING_A ----
  //---- VIDEO BOX (SPORT LANDING J) ----
  if (document.getElementById("video_box_landing")) {
    new Splide("#video_box_landing", {
      gap: '20px',
      perMove: 1,
      perPage: 5,
      type: "loop",
      direction: "rtl",
      pagination: false,
      adaptiveHeight: false,
      breakpoints: {
        800: {
          perPage: 2,
        },
        600: {
          perPage: 1,
          gap: '12px',
        },
      }
    }).mount();
  }
  //---- END OF VIDEO BOX (SPORT LANDING J) ----
  // ----- ARCHIVE ICON -----
  if (document.querySelector(".archive_news_type .flip")) {
    var archive = document.querySelector(".archive_news_type .flip");
    archive.addEventListener("click", toggleFlip);

    function toggleFlip() {
      var panel = document.querySelector(".archive_news_type .panel");
      if (panel.style.display === "block") {
        panel.style.display = "none";
        archive.classList.remove("flip_toggle");
      } else {
        archive.classList.add("flip_toggle");
        panel.style.display = "block";
      }
    }
  }
  // ----- END OF ARCHIVE ICONS -----
  // ----- ARCHIVE SERVICE ICON -----
  if (document.querySelector(".archive_service .flip")) {
    var archiveService = document.querySelector(".archive_service .flip");
    archiveService.addEventListener("click", toggleFlip);

    function toggleFlip() {
      var panel = document.querySelector(".archive_service .panel");
      if (panel.style.display === "block") {
        panel.style.display = "none";
        archiveService.classList.remove("flip_toggle");
      } else {
        archiveService.classList.add("flip_toggle");
        panel.style.display = "block";
      }
    }
  }
  // ----- END OF ARCHIVE SERVICE ICONS -----
  // ---- SCROLL TO TOP ----
  if (document.querySelector("#scroll_to_top")) {
    const scrollToTopBtn = document.getElementById('scroll_to_top');
    window.addEventListener('scroll', () => {
      if (window.scrollY > 200) {
        scrollToTopBtn.classList.remove('hidden_button');
      } else {
        scrollToTopBtn.classList.add('hidden_button');
      }
    });
    scrollToTopBtn.addEventListener('click', () => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    });
  }
  // ---- END OF SCROLL TO TOP ----
  //---- EMERGENCY NEWS ----
  const emergencyNews = document.querySelector(".emergency_news");
  if (emergencyNews) {
    const closeButton = document.querySelector(".close_emergency_news");
    const header = document.querySelector("header"); // Ensure the header is defined
    // Close emergency news
    if (closeButton) {
      closeButton.addEventListener("click", () => {
        emergencyNews.classList.add("hidden_emergency_news");
      });
    }
    // Fix emergency news on scroll
    let lastScrollY = window.scrollY;
    window.addEventListener("scroll", () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY > lastScrollY && currentScrollY > header.offsetHeight) {
        // Scrolling down past the header
        emergencyNews.classList.add("emergency_new_fix");
      } else if (currentScrollY < header.offsetHeight) {
        // Scrolling up above the header
        emergencyNews.classList.remove("emergency_new_fix");
      }
      lastScrollY = currentScrollY;
    });
  }
  //---- END OF EMERGENCY NEWS ----
  //---- GALLERY TWIG ----
  document.querySelectorAll(".inline_gallery").forEach((gallery) => {
    new Splide(gallery, {
      type: "loop",
      autoplay: true,
      interval: 4000,
      direction: "rtl",
      adaptiveHeight: true,
    }).mount();
  });
  //---- END OF GALLERY TWIG ----
});